/*
  +--------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     状态管理入口
  +--------------------------------------------------------------------------------------
*/

import Vue from "vue";
import Vuex from "vuex";
import commonStore from "./modules/commonStore";
import godStore from "./modules/godStore";
import mesStore from "./modules/mesStore";
import permissionStore from "./modules/permissionStore";
import userStore from "./modules/userStore";
import pmStore from "./modules/pmStore";
import qcStore from "./modules/qcStore";
import equipStore from "./modules/equipStore";
import middleStore from "./modules/middleStore"
import getters from "./getters";

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    commonStore,
    godStore,
    mesStore,
    permissionStore,
    userStore,
    pmStore,
    qcStore,
    equipStore,
    middleStore
  },
  getters
});

export default store;
